import React, {useState, useEffect} from "react";

import type {SelectProps} from 'antd';
import { Select, TreeSelect } from "antd";
import OrganizationApi from "../../api/OrganizationApi";
import type { Organization } from "../../type/OrganizationType";
import { ProFormSelect, ProFormTreeSelect } from "@ant-design/pro-form";

const {TreeNode} = TreeSelect;

const OrganizationSelector:React.FC<any> = (props)=>{


    return (
        <ProFormTreeSelect
            allowClear
            request={async ()=>{
                const treeList = await OrganizationApi.findOrganizationTree({
                    deletedFlag: false,
                });

                return treeList;
            }}
            fieldProps={{
                fieldNames:{
                    value: 'id',
                    label: 'name',
                    children: 'children',
                }
            }}
            {...props}
        >
        </ProFormTreeSelect>
    );
};

export default OrganizationSelector;